import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Создать рейс",
    loading: _ctx.loading,
    onSubmit: _ctx.emitCreate,
    onCancel: _ctx.emitCancel,
    overflow: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_new_select, {
          placeholder: "Перевозчик",
          loading: _ctx.data_state.carriers.is_loading,
          failed: _ctx.data_state.carriers.is_failed,
          disabled: _ctx.loading,
          "is-invalid": _ctx.validation$.companyId.$error,
          "validation-errors": _ctx.validation$.companyId.$errors,
          "search-without-refresh": "",
          options: _ctx.data_state.carriers.list,
          value: _ctx.payload.companyId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.companyId) = $event)),
          onRefresh: _ctx.loadCarriers,
          onLoadmore: _ctx.loadMoreCarriers,
          onSearch: _ctx.searchCarriers,
          onOptionBySearch: _ctx.unshiftFindedCarrier
        }, null, 8, ["loading", "failed", "disabled", "is-invalid", "validation-errors", "options", "value", "onRefresh", "onLoadmore", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_new_select, {
          placeholder: "Город отправки",
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          disabled: _ctx.loading,
          "is-invalid": _ctx.validation$.fromCityId.$error,
          "validation-errors": _ctx.validation$.fromCityId.$errors,
          "search-without-refresh": "",
          options: _ctx.data_state.cities.list,
          value: _ctx.payload.fromCityId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.fromCityId) = $event)),
          onRefresh: _ctx.loadCities
        }, null, 8, ["loading", "failed", "disabled", "is-invalid", "validation-errors", "options", "value", "onRefresh"]),
        _createVNode(_component_new_select, {
          placeholder: "Город прибытия",
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          disabled: _ctx.loading,
          "is-invalid": _ctx.validation$.toCityId.$error,
          "validation-errors": _ctx.validation$.toCityId.$errors,
          "search-without-refresh": "",
          options: _ctx.data_state.cities.list,
          value: _ctx.payload.toCityId,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.toCityId) = $event)),
          onRefresh: _ctx.loadCities
        }, null, 8, ["loading", "failed", "disabled", "is-invalid", "validation-errors", "options", "value", "onRefresh"]),
        _createVNode(_component_new_input, {
          placeholder: "Адрес загрузки",
          disabled: _ctx.loading,
          value: _ctx.payload.loadAddress,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.loadAddress) = $event)),
          "is-invalid": _ctx.validation$.loadAddress.$error,
          "validation-errors": _ctx.validation$.loadAddress.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_input, {
          placeholder: "ФИО (Грузоотправитель)",
          disabled: _ctx.loading,
          value: _ctx.payload.receiverFullName,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.receiverFullName) = $event)),
          "is-invalid": _ctx.validation$.receiverFullName.$error,
          "validation-errors": _ctx.validation$.receiverFullName.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_input, {
          placeholder: "Телефон (Грузоотправитель)",
          disabled: _ctx.loading,
          value: _ctx.payload.receiverPhoneNumber,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.receiverPhoneNumber) = $event)),
          "is-invalid": _ctx.validation$.receiverPhoneNumber.$error,
          "validation-errors": _ctx.validation$.receiverPhoneNumber.$errors,
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"]),
        _createVNode(_component_new_input, {
          placeholder: "Дата загрузки",
          type: "date",
          disabled: _ctx.loading,
          value: _ctx.payload.dateOfLoad,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.dateOfLoad) = $event)),
          "is-invalid": _ctx.validation$.dateOfLoad.$error,
          "validation-errors": _ctx.validation$.dateOfLoad.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_input, {
          placeholder: "Адрес разгрузки",
          disabled: _ctx.loading,
          value: _ctx.payload.unloadAddress,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payload.unloadAddress) = $event)),
          "is-invalid": _ctx.validation$.unloadAddress.$error,
          "validation-errors": _ctx.validation$.unloadAddress.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_input, {
          placeholder: "ФИО (Грузополучатель)",
          disabled: _ctx.loading,
          value: _ctx.payload.senderFullName,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payload.senderFullName) = $event)),
          "is-invalid": _ctx.validation$.senderFullName.$error,
          "validation-errors": _ctx.validation$.senderFullName.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_input, {
          placeholder: "Телефон (Грузополучатель)",
          disabled: _ctx.loading,
          value: _ctx.payload.senderPhoneNumber,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payload.senderPhoneNumber) = $event)),
          "is-invalid": _ctx.validation$.senderPhoneNumber.$error,
          "validation-errors": _ctx.validation$.senderPhoneNumber.$errors,
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"]),
        _createVNode(_component_new_input, {
          placeholder: "Дата разгрузки",
          type: "date",
          disabled: _ctx.loading,
          value: _ctx.payload.dateOfUnload,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payload.dateOfUnload) = $event)),
          "is-invalid": _ctx.validation$.dateOfUnload.$error,
          "validation-errors": _ctx.validation$.dateOfUnload.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_input, {
          placeholder: "Стоимость перевозки",
          disabled: _ctx.loading,
          value: _ctx.payload.costOfTransportation,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.payload.costOfTransportation) = $event)),
          "is-invalid": _ctx.validation$.costOfTransportation.$error,
          "validation-errors": _ctx.validation$.costOfTransportation.$errors,
          maska: _ctx.PRICE_MASK
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"]),
        _createVNode(_component_new_input, {
          placeholder: "Кубатура",
          value: _ctx.payload.cubature,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payload.cubature) = $event)),
          "is-invalid": _ctx.validation$.cubature.$error,
          "validation-errors": _ctx.validation$.cubature.$errors,
          disabled: _ctx.loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_new_input, {
          placeholder: "Характеристики груза",
          disabled: _ctx.loading,
          value: _ctx.payload.natureOfCargo,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payload.natureOfCargo) = $event)),
          "is-invalid": _ctx.validation$.natureOfCargo.$error,
          "validation-errors": _ctx.validation$.natureOfCargo.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
      ])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}